import axios from 'axios';
import {HttpUtils} from "./common/HttpUtils";

export { AuthService };

function AuthService(baseUrl) {

    if (!baseUrl) {
        this.baseUrl = process.env.VUE_APP_AUTH_URL;
    } else {
        this.baseUrl = baseUrl;
    }

    this.headers = HttpUtils.getHttpHeaders(null, 'text/json');

}

AuthService.prototype.reValidate = function(){
    return new Promise( (resolve, reject) => {

        let authResult = {
            jwt: '',
            authenticated: false,
            message: '',
            sessionId: '',
            status: 0
        };

        let sessionId = HttpUtils.getCookie("adm-"+window.appInstanceId);

        console.debug(`[d204186] session: ${sessionId} for adm-${window.appInstanceId}`);
        if (sessionId == null){
            reject();
            return;
        }

        let headers = HttpUtils.getHttpHeaders(sessionId, null);
        axios.get(this.baseUrl + '/revalidate', {headers: headers}).then(response => {

             if (response.status === 200) {
                 authResult.jwt = response.data.token;
                 authResult.status = 200;
                 authResult.authenticated = true;
                 authResult.sessionId = response.data.session;
                 resolve(authResult);
             }

        }).catch(e => {

            if (e != null){
                console.error(e);
            }

            reject(e);


        })

    });
};


AuthService.prototype.checkSession = function(promise){


    axios.get(this.baseUrl + '/session/check', {headers: this.headers}).then(response => {

        if (promise) {
            promise.result(true);
        }
        else
        {
            console.warn("invalid promise")
        }

    }).catch(e => {

        if (e.response) {
            if (e.response.status === 422) {
                promise.result(false);
            }
        }
        else{

            console.error(e);
            promise.result(false);
            promise.error(e);
        }

    })
};


AuthService.prototype.login = function(userId, password) {

    let authResult = {
        jwt: '',
        authenticated: false,
        message: '',
        sessionId: '',
        status: 0

    };

    let requestData = {
        userId: userId,
        password: password
    };

    return new Promise((res, rej) => {

        axios.post(this.baseUrl, requestData, {headers: this.headers}).then(response => {

            let data = response.data;
            if (!data){
                authResult.status = 401;
                authResult.authenticated = false;
                authResult.message = "Server problems trying to authenticate.";

                res(authResult);
                return;

            }


            authResult.jwt = data.token;
            authResult.status = 200;
            authResult.authenticated = true;
            authResult.sessionId = data.session;

            HttpUtils.setCookie("adm-"+window.appInstanceId, authResult.sessionId);

            res(authResult);
        }).catch((e) => {

            if (e.response) {
                console.error(e);
                if (e.response.status === 401) {
                    authResult.status = 401;
                    authResult.authenticated = false;
                    authResult.message = "Couldn't find your account. Verify your credentials.";

                    res(authResult);

                } else {

                    if (e.response.status === 500) {
                        authResult.status = e.response.status;
                        authResult.authenticated = false;
                        authResult.message = "Internal server error - please try again later";

                        res(authResult);
                    } else {
                        rej(e);
                    }
                }
            }
            else{
                console.error(e)
            }
        })
    });
};

AuthService.prototype.logout = function(auth) {

    return new Promise((resolve, reject) => {
        this.headers['authorization'] = 'bearer ' + auth.jwt;

        axios.get(this.baseUrl + '/logout', {headers: this.headers}).then(response => {

            if (response != null) {
                if (response.status === 200 || response.status === 201) {
                    resolve();
                } else {
                    reject();
                }
            }

        }).catch(e => {
            reject(e);
        });
    });


};

AuthService.prototype.getProfile = function(auth, success, failure) {

    this.headers = HttpUtils.getHttpHeaders(auth, 'text/json');

    let profile = {
        userId: '',
        name: '',
        emailAddress: '',
        roles: [],
        companyId: '',
        companyName: '',
        companyLogo: '',
    };

    axios.get(this.baseUrl + '/profile', {headers: this.headers}).then(response => {

        let responseProfile = response.data;
        profile.name = `${responseProfile.firstName} ${responseProfile.lastName}`;
        profile.roles = responseProfile.roles;
        profile.userId = responseProfile.userId;
        profile.emailAddress = responseProfile.emailAddress;
        profile.companyName = responseProfile.company.name;
        profile.companyId = responseProfile.company.id;
        profile.companyLogo = responseProfile.company.logoUri;
        profile.branches = responseProfile.branches;


        success(profile);


    }).catch((e) => {
        console.error(e);

        failure(e);

    });


};